import { ServiceBase } from './ServiceBase'

export class KPI extends ServiceBase {}
